import type { ContainerLayoutViewModel } from '../types';

export type UpdateWorkspaceLayoutAction = {
    type: 'updateWorkspaceLayout';
    containerId: string;
    layoutUpdates: Partial<ContainerLayoutViewModel>;
};

export const updateWorkspaceLayout = (
    containerId: string,
    layoutUpdates: Partial<ContainerLayoutViewModel>,
): UpdateWorkspaceLayoutAction => ({ containerId, layoutUpdates, type: 'updateWorkspaceLayout' });

export interface LayoutUpdate {
    containerId: string;
    layout: Partial<ContainerLayoutViewModel>;
}

export type UpdateMultipleWorkspaceLayoutsAction = {
    type: 'updateMultipleWorkspaceLayouts';
    updates: LayoutUpdate[];
};

export const updateMultipleWorkspaceLayouts = (updates: LayoutUpdate[]): UpdateMultipleWorkspaceLayoutsAction => ({
    type: 'updateMultipleWorkspaceLayouts',
    updates,
});

export type LayoutAction = UpdateWorkspaceLayoutAction | UpdateMultipleWorkspaceLayoutsAction;
